(() => {
  const register = (name, initializer) => {
    if (window.SafeWalkV51Product?.register) window.SafeWalkV51Product.register(name, initializer);
    else (window.SafeWalkV51ProductQueue ||= []).push([name, initializer]);
  };
  register('purchase', ({ root, parseJson, listen, addCleanup }) => {
    const form = root.querySelector('.swv5-form');
    const variantsNode = root.querySelector('[data-swv5-variants]');
    if (!form || !variantsNode) return;
    let variants = [];
    try {
      const parsed = JSON.parse(variantsNode.textContent || '[]');
      variants = Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      variants = [];
    }
    const config = parseJson('[data-swv5-config]', {}), stickyActions = [...document.querySelectorAll('[data-swv51-sticky-actions]')].filter((actions) => [...actions.querySelectorAll('[data-swv5-submit]')].some((button) => button.getAttribute('form') === form.id)), scopedNodes = (selector) => [...new Set([...root.querySelectorAll(selector), ...stickyActions.flatMap((actions) => [...actions.querySelectorAll(selector)])])];
    const idInput = root.querySelector('[data-variant-id]');
    const atcButtons = Array.from(root.querySelectorAll('[data-atc]'));
    const defaultAtc = atcButtons[0] || null;
    const atcPrices = Array.from(root.querySelectorAll('[data-atc-price]'));
    const mobilePrices = scopedNodes('[data-mobile-price]');
    const desktopPrices = scopedNodes('[data-desktop-price]');
    const stickySupportingTexts = scopedNodes('[data-sticky-supporting-text]');
    const submitButtons = scopedNodes('[data-swv5-submit]');
    const stickyAtcLabels = scopedNodes('[data-sticky-atc-label]');
    const stickyDefaultLabels = new Map(stickyAtcLabels.map((node) => [node, node.textContent?.trim() || '']));
    const errorNodes = Array.from(root.querySelectorAll('[data-form-error]'));
    const packageSelectors = Array.from(root.querySelectorAll('[data-package-selector]'));
    const packageProperty = root.querySelector('[data-package-property]');
    const packageDiscountProperty = root.querySelector('[data-package-discount-property]');
    const packageTotalProperty = root.querySelector('[data-package-total-property]');
    const packageGroupProperty = root.querySelector('[data-package-group-property]');
    const selectionControls = Array.from(root.querySelectorAll('[data-option-value], [data-package-input]'));
    const personalizationControls = Array.from(root.querySelectorAll(
      '.swv51-personalization input[data-safewalk-personalization-key], .swv51-personalization input[name^="properties["]'
    ));
    const receiptPackageTitles = Array.from(root.querySelectorAll('[data-receipt-package-title]'));
    const receiptItems = Array.from(root.querySelectorAll('[data-receipt-items]'));
    const receiptPackagePrices = Array.from(root.querySelectorAll('[data-receipt-package-price]'));
    const receiptCompares = Array.from(root.querySelectorAll('[data-receipt-compare]'));
    const receiptSavings = Array.from(root.querySelectorAll('[data-receipt-savings]'));
    const receiptSavingsRows = Array.from(root.querySelectorAll('[data-receipt-savings-row]'));
    const receiptTotals = Array.from(root.querySelectorAll('[data-receipt-total]'));
    const currency = root.dataset.currency || config.currency || 'ILS', addonMode = root.dataset.offerModel === 'addons';
    const hideAccessoryAddons = root.dataset.hideAccessoryAddons === 'true';
    const giftMode = root.dataset.giftMode || 'transitional_dual';
    const giftContractMode = root.dataset.giftContractMode || 'legacy_properties';
    const cartGiftVariantId = Number(root.dataset.cartGiftVariantId || 0);
    const cartGiftProductId = Number(root.dataset.cartGiftProductId || 0);
    const cartGiftRequired = root.dataset.cartGiftRequired === 'true';
    const realGiftsRequired = root.dataset.realGiftsRequired === 'true';
    const realGiftConfig = window.SafeWalkV6RealGifts?.readRootConfig(root) || { identities: window.SafeWalkV6RealGiftRegistry?.identities || [], realGiftIds: window.SafeWalkV6RealGiftRegistry?.realGiftIds || {} };
    const realGiftIdentities = realGiftConfig.identities;
    const packageDiscounts = {
      harness_only: 0,
      harness_bungee: Number(root.dataset.packageBungeeDiscount || 22),
      full_set: Number(root.dataset.packageFullDiscount || 22)
    };
    const packageVariantData = {};
    root.querySelectorAll('[data-package-variants]').forEach((node) => {
      try {
        const parsed = JSON.parse(node.textContent || '[]');
        packageVariantData[node.dataset.packageVariants] = Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        packageVariantData[node.dataset.packageVariants] = [];
      }
    });
    const packageOptionNames = {};
    root.querySelectorAll('[data-package-option-names]').forEach((node) => {
      try {
        const parsed = JSON.parse(node.textContent || '[]');
        packageOptionNames[node.dataset.packageOptionNames] = Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        packageOptionNames[node.dataset.packageOptionNames] = [];
      }
    });
    const accessoryVariants = window.SafeWalkV51AccessoryVariants;
    let activeSubmitter = null;
    let activePackageInput = null;
    let selectedPackageKind = '';
    const packageLabel = (kind, preferredCard = null) => {
      const activeCard = activePackageInput?.closest('[data-package-card]');
      const card = preferredCard?.dataset.packageKind === kind
        ? preferredCard
        : activeCard?.dataset.packageKind === kind
          ? activeCard
          : root.querySelector(`[data-package-card][data-package-kind="${kind}"]`);
      const configured = config.packages?.[kind] || {};
      return {
        title: card?.dataset.packageTitle || configured.title || (kind === 'harness_only' ? receiptPackageTitles[0]?.textContent?.trim() : '') || '',
        items: card?.dataset.packageItems || configured.items || (kind === 'harness_only' ? receiptItems[0]?.textContent?.trim() : '') || '',
        savingsTemplate: card?.dataset.packageSavingsTemplate || configured.savingsTemplate || '',
        unavailableLabel: card?.dataset.packageUnavailableLabel || configured.unavailableLabel || ''
      };
    };
    const configuredLabels = config.labels || {};
    const labelDataKeys = {
      add: 'labelAdd',
      soldOut: 'labelSoldOut',
      unavailable: 'labelUnavailable',
      adding: 'labelAdding',
      added: 'labelAdded',
      error: 'labelError',
      missingGift: 'labelMissingGift',
      missingPackage: 'labelMissingPackage',
      incompletePersonalization: 'labelIncompletePersonalization'
    };
    const atcForNode = (node) => {
      if (!node) return null;
      if (node.matches?.('[data-atc]')) return node;
      return node.closest?.('[data-atc]') || null;
    };
    const labelFor = (key, source = activeSubmitter) => {
      const button = atcForNode(source) || defaultAtc;
      const configured = configuredLabels[key] || '';
      const visibleAddLabel = key === 'add' ? button?.querySelector('[data-atc-label]')?.textContent?.trim() || '' : '';
      return button?.dataset[labelDataKeys[key]] || configured || visibleAddLabel;
    };
    const labels = {};
    Object.keys(labelDataKeys).forEach((key) => {
      Object.defineProperty(labels, key, { enumerable: true, get: () => labelFor(key) });
    });
    const kaching = {
      deal: root.dataset.kachingDealId || '',
      p1Bar: root.dataset.kachingP1BarId || '',
      p2Bar: root.dataset.kachingP2BarId || '',
      p3Bar: root.dataset.kachingP3BarId || '',
      p2Bungee: root.dataset.kachingP2BungeeId || '',
      p3Bungee: root.dataset.kachingP3BungeeId || '',
      p3Collar: root.dataset.kachingP3CollarId || '',
      p2Gift: root.dataset.kachingP2GiftId || '',
      p3Gift: root.dataset.kachingP3GiftId || '',
      p1Gift: root.dataset.kachingP1GiftId || '',
      realGiftIds: realGiftConfig.realGiftIds,
      bungeeProductId: Number(root.dataset.kachingBungeeProductId || 0),
      collarProductId: Number(root.dataset.kachingCollarProductId || 0),
      giftProductId: Number(root.dataset.kachingGiftProductId || 0)
    };
    const selectionDisabledState = new Map();
    const personalizationReadOnlyState = new Map();
    let packageState = null;
    let busy = false;
    let initialized = false;

    const formatMoney = (cents) => {
      const value = Number(cents || 0) / 100;
      try {
        const hasAgorot = Math.abs(Number(cents || 0)) % 100 !== 0;
        return new Intl.NumberFormat('he-IL', {
          style: 'currency',
          currency,
          minimumFractionDigits: hasAgorot ? 2 : 0,
          maximumFractionDigits: 2
        }).format(value).replace(/\s/g, ' ');
      } catch (error) {
        return [currency, value.toFixed(2).replace(/\.00$/, '')].filter(Boolean).join(' ');
      }
    };
    const normalizeColor = accessoryVariants?.normalizeColor || ((value = '') => String(value).trim().toLowerCase());
    const normalizeSize = accessoryVariants?.normalizeSize || ((value = '') => String(value).trim().toUpperCase());
    const formatSizeLabel = (value = '') => normalizeSize(value) || value;
    const currentColor = () => root.querySelector('.swv5-option--color input:checked')?.value || '';
    const currentSize = () => root.querySelector('.swv5-option--size input:checked')?.value || '';
    const currentColorKey = () => normalizeColor(currentColor());
    const currentSizeKey = () => normalizeSize(currentSize());
    packageSelectors.forEach((selector, index) => {
      const rawId = selector.dataset.packageSelectorId || String(index + 1);
      const groupId = `${root.dataset.swv5Section || 'product'}-${rawId}`.replace(/[^a-zA-Z0-9_-]/g, '-');
      selector.querySelectorAll('[data-package-input]').forEach((input) => {
        input.name = `swv5-package-choice-${groupId}`;
      });
    });
    const packageInputs = Array.from(root.querySelectorAll('[data-package-input]'));
    activePackageInput = packageInputs.find((input) => input.checked && !input.disabled)
      || packageInputs.find((input) => !input.disabled)
      || packageInputs[0]
      || null;
    selectedPackageKind = activePackageInput?.value || root.dataset.defaultPackageKind || '';
    const syncPackageInputs = (kind, sourceInput = null) => {
      selectedPackageKind = kind || selectedPackageKind || root.dataset.defaultPackageKind || packageInputs.find((input) => !input.disabled)?.value || '';
      if (sourceInput?.value === selectedPackageKind) activePackageInput = sourceInput;
      packageSelectors.forEach((selector) => {
        let matched = false;
        selector.querySelectorAll('[data-package-input]').forEach((input) => {
          const shouldCheck = !matched && input.value === selectedPackageKind;
          input.checked = shouldCheck;
          if (shouldCheck) matched = true;
        });
      });
      if (!activePackageInput || activePackageInput.value !== selectedPackageKind) {
        activePackageInput = packageInputs.find((input) => input.checked && input.value === selectedPackageKind)
          || packageInputs.find((input) => input.value === selectedPackageKind)
          || null;
      }
    };
    syncPackageInputs(selectedPackageKind, activePackageInput);
    const selectedPackageKey = () => selectedPackageKind || activePackageInput?.value || root.dataset.defaultPackageKind || '';
    const packageBarId = (kind) => kind === 'full_set' ? kaching.p3Bar : kind === 'harness_bungee' ? kaching.p2Bar : kaching.p1Bar;
    const variantComparePrice = (variant) => Number(variant?.compare_at_price || 0) || Number(variant?.price || 0);
    const discountedLinePrice = (cents, discountPercent) => Math.round(Number(cents || 0) * (100 - discountPercent) / 100);
    const exactBungeeVariant = () => {
      return accessoryVariants?.findVariant({
        variants: packageVariantData.bungee,
        optionNames: packageOptionNames.bungee,
        color: currentColor(),
        colorOptionLabels: root.dataset.accessoryColorOptionLabels,
        sizeOptionLabels: root.dataset.accessorySizeOptionLabels
      }) || null;
    };
    const exactCollarVariant = () => {
      return accessoryVariants?.findVariant({
        variants: packageVariantData.collar,
        optionNames: packageOptionNames.collar,
        color: currentColor(),
        size: currentSize(),
        colorOptionLabels: root.dataset.accessoryColorOptionLabels,
        sizeOptionLabels: root.dataset.accessorySizeOptionLabels
      }) || null;
    };
    const resolvePackage = (mainVariant, kind = selectedPackageKey(), sourceCard = null) => {
      const copy = packageLabel(kind, sourceCard);
      const discountPercent = Number(packageDiscounts[kind] || 0);
      const bungeeVariant = kind === 'harness_bungee' || kind === 'full_set' ? exactBungeeVariant() : null;
      const collarVariant = kind === 'full_set' ? exactCollarVariant() : null;
      const requiredVariants = [mainVariant];
      if (kind === 'harness_bungee' || kind === 'full_set') requiredVariants.push(bungeeVariant);
      if (kind === 'full_set') requiredVariants.push(collarVariant);
      const hasExactVariants = requiredVariants.every(Boolean);
      const available = hasExactVariants && requiredVariants.every((variant) => variant.available);
      const total = requiredVariants.reduce((sum, variant) => sum + (variant ? discountedLinePrice(variant.price, discountPercent) : 0), 0);
      const compare = requiredVariants.reduce((sum, variant) => sum + (variant ? variantComparePrice(variant) : 0), 0);
      return {
        kind,
        discountPercent,
        mainVariant,
        bungeeVariant,
        collarVariant,
        total,
        compare,
        savings: Math.max(0, compare - total),
        available,
        hasExactVariants,
        barId: packageBarId(kind),
        title: copy.title,
        items: copy.items
      };
    };
    const optionIndexFor = (input) => Number(input?.closest('.swv5-option')?.dataset.optionIndex);
    const syncVariantInputs = (sourceInput) => {
      const position = optionIndexFor(sourceInput);
      if (!Number.isInteger(position) || position < 0) return;
      root.querySelectorAll(`.swv5-option[data-option-index="${position}"]`).forEach((option) => {
        let matched = false;
        option.querySelectorAll('[data-option-value]').forEach((input) => {
          const shouldCheck = !matched && input.value === sourceInput.value;
          input.checked = shouldCheck;
          if (shouldCheck) matched = true;
        });
      });
    };
    const selectedOptions = () => {
      const optionCount = Math.max(0, ...variants.map((variant) => Array.isArray(variant.options) ? variant.options.length : 0));
      const selected = Array(optionCount).fill('');
      root.querySelectorAll('.swv5-option').forEach((option) => {
        const checked = option.querySelector('input:checked');
        if (!checked) return;
        const indexedPosition = Number(option.dataset.optionIndex);
        const namedPosition = Number(String(checked.name || '').match(/(\d+)$/)?.[1] || 0) - 1;
        const position = Number.isInteger(indexedPosition) && indexedPosition >= 0 ? indexedPosition : namedPosition;
        if (position >= 0 && position < selected.length && !selected[position]) selected[position] = checked.value;
      });
      return selected;
    };
    const findVariant = () => {
      const selected = selectedOptions();
      const currentId = Number(idInput?.value || 0);
      if (!selected.length || selected.some((value) => !value)) {
        return variants.find((variant) => Number(variant.id) === currentId) || variants[0] || null;
      }
      return variants.find((variant) => {
        return Array.isArray(variant.options) && selected.every((value, index) => variant.options[index] === value);
      }) || null;
    };
    const setStatus = (key, preserveStickyDefaults = false) => {
      atcButtons.forEach((button) => {
        const node = button.querySelector('[data-atc-label]');
        if (node) node.textContent = labelFor(key, button);
      });
      const stickyLabel = labelFor(key);
      stickyAtcLabels.forEach((node) => {
        node.textContent = preserveStickyDefaults ? stickyDefaultLabels.get(node) || stickyLabel : stickyLabel;
      });
    };
    const setSuccess = (success) => atcButtons.forEach((button) => button.classList.toggle('is-success', Boolean(success)));
    const updatePackageSurfaces = (state) => {
      if (!state) return;
      if (addonMode) { if (packageProperty) packageProperty.value = 'harness_only'; if (packageDiscountProperty) packageDiscountProperty.value = '0'; if (packageTotalProperty) packageTotalProperty.value = String(state.mainVariant?.price || 0); submitButtons.forEach((button) => { button.disabled = busy || !state.mainVariant?.available; }); return; }
      const formattedTotal = formatMoney(state.total);
      const formattedCompare = formatMoney(state.compare);
      const formattedSavings = formatMoney(state.savings);
      atcPrices.forEach((node) => { node.textContent = formattedTotal; });
      mobilePrices.forEach((node) => { node.textContent = formattedTotal; });
      desktopPrices.forEach((node) => { node.textContent = formattedTotal; });
      stickySupportingTexts.forEach((node) => { node.textContent = state.kind === 'full_set' ? node.dataset.homeText : node.dataset.pickupText; });
      receiptPackageTitles.forEach((node) => { node.textContent = state.title; });
      receiptItems.forEach((node) => { node.textContent = state.items; });
      receiptPackagePrices.forEach((node) => { node.textContent = formattedTotal; });
      receiptTotals.forEach((node) => { node.textContent = formattedTotal; });
      receiptCompares.forEach((node) => {
        node.textContent = formattedCompare;
        node.hidden = state.compare <= state.total;
      });
      receiptSavings.forEach((node) => { node.textContent = formattedSavings; });
      receiptSavingsRows.forEach((node) => { node.hidden = state.savings <= 0; });
      if (packageProperty) packageProperty.value = state.kind;
      if (packageDiscountProperty) packageDiscountProperty.value = String(state.discountPercent);
      if (packageTotalProperty) packageTotalProperty.value = String(state.total);
      submitButtons.forEach((button) => { button.disabled = busy || !state.available; });
      const available = !busy && state.available;
      setStatus(busy ? 'adding' : state.available ? 'add' : state.mainVariant?.available ? 'unavailable' : 'soldOut', available);
    };
    const emitState = (state) => { if (addonMode) return;
      const leashKind = state?.bungeeVariant ? 'bungee' : 'none';
      document.body.dataset.swv5LeashChoice = leashKind;
      root.dispatchEvent(new CustomEvent('swv5:leash-change', { bubbles: true, detail: { kind: leashKind } }));
      root.dispatchEvent(new CustomEvent('swv5:package-change', {
        bubbles: true,
        detail: {
          kind: state?.kind,
          discountPercent: state?.discountPercent,
          totalCents: state?.total,
          harnessVariantId: state?.mainVariant?.id || null,
          bungeeVariantId: state?.bungeeVariant?.id || null,
          collarVariantId: state?.collarVariant?.id || null,
          kachingBarId: state?.barId
        }
      }));
    };
    const updatePackageSelection = (mainVariant = findVariant(), sourceInput = null) => {
      if (sourceInput) syncPackageInputs(sourceInput.value, sourceInput);
      else syncPackageInputs(selectedPackageKey(), activePackageInput);
      root.querySelectorAll('[data-package-card]').forEach((card) => {
        const kind = card.dataset.packageKind;
        const copy = packageLabel(kind, card);
        const state = resolvePackage(mainVariant, kind, card);
        root.dispatchEvent(new CustomEvent('swv5:package-card-state', {
          detail: { card, state }
        }));
        const input = card.querySelector('[data-package-input]');
        const status = card.querySelector('[data-package-status]');
        const selected = Boolean(input?.checked);
        card.classList.toggle('is-selected', selected);
        card.classList.toggle('is-unavailable', !state.available);
        card.setAttribute('aria-disabled', String(!state.available));
        if (input) input.disabled = busy || !state.available;
        const price = card.querySelector('[data-package-price]');
        const compare = card.querySelector('[data-package-compare]');
        const savings = card.querySelector('[data-package-savings]');
        if (price) price.textContent = formatMoney(state.total);
        if (compare) {
          compare.textContent = formatMoney(state.compare);
          compare.hidden = state.compare <= state.total;
        }
        if (savings) {
          const savingsTemplate = copy.savingsTemplate, savingsPercent = state.compare > 0 ? Math.round(state.savings * 100 / state.compare) : 0;
          savings.textContent = savingsTemplate
            ? savingsTemplate.replace(/\[amount\]|\{amount\}/g, formatMoney(state.savings)).replace(/\[percent\]|\{percent\}/g, String(savingsPercent))
            : '';
          savings.hidden = state.savings <= 0;
        }
        if (status) {
          status.textContent = copy.unavailableLabel || (state.hasExactVariants ? labels.soldOut : labels.unavailable);
          status.hidden = state.available;
        }
      });
      const key = selectedPackageKey();
      const sourceCard = activePackageInput?.closest('[data-package-card]') || null;
      packageState = resolvePackage(mainVariant, key, sourceCard);
      updatePackageSurfaces(packageState);
      emitState(packageState);
      return packageState;
    };
    const updateVariant = (colorChanged = false) => {
      root.querySelectorAll('.swv5-option').forEach((option) => {
        const label = option.querySelector('[data-selected-option]');
        const checked = option.querySelector('input:checked');
        if (label && checked) {
          label.textContent = option.classList.contains('swv5-option--size') ? formatSizeLabel(checked.value) : checked.value;
        }
      });
      const variant = findVariant();
      if (idInput && variant) idInput.value = String(variant.id);
      updatePackageSelection(variant);
      root.dispatchEvent(new CustomEvent('swv5:variant-change', {
        bubbles: true,
        detail: {
          variant,
          colorChanged,
          colorMediaId: root.querySelector('[data-color-media-id]:checked')?.dataset.colorMediaId || ''
        }
      }));
      initialized = true;
      return variant;
    };
    const setSubmittingState = (nextBusy) => {
      busy = Boolean(nextBusy);
      selectionControls.forEach((control) => {
        if (busy) {
          if (!selectionDisabledState.has(control)) selectionDisabledState.set(control, control.disabled);
          control.disabled = true;
        } else if (selectionDisabledState.has(control)) {
          control.disabled = selectionDisabledState.get(control);
          selectionDisabledState.delete(control);
        }
      });
      personalizationControls.forEach((control) => {
        if (busy) {
          if (!personalizationReadOnlyState.has(control)) personalizationReadOnlyState.set(control, control.readOnly);
          control.readOnly = true;
        } else if (personalizationReadOnlyState.has(control)) {
          control.readOnly = personalizationReadOnlyState.get(control);
          personalizationReadOnlyState.delete(control);
        }
      });
      updatePackageSelection(findVariant());
      submitButtons.forEach((button) => button.setAttribute('aria-busy', String(busy)));
    };
    const showError = (message) => {
      errorNodes.forEach((node, index) => {
        node.textContent = message || labels.error;
        node.hidden = false;
        if (index === 0) node.focus?.();
      });
    };
    const showErrorStatus = (key) => showError(labelFor(key));
    const clearError = () => {
      errorNodes.forEach((node) => { node.hidden = true; });
    };
    const setActiveSubmitter = (submitter) => {
      if (submitter?.matches?.('[data-swv5-submit]')) activeSubmitter = submitter;
    };
    const createGroupId = () => {
      const groupId = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : `swv5-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      if (packageGroupProperty) packageGroupProperty.value = groupId;
      return groupId;
    };
    const properties = () => {
      const result = {};
      new FormData(form).forEach((value, key) => {
        if (!key.startsWith('properties[') || !value) return;
        result[key.slice(11, -1)] = String(value);
      });
      return result;
    };
    const personalizationKey = (input) => window.SafeWalkV6RealGifts?.personalizationControlKey(input)
      || input.name?.slice(11, -1) || '';
    const personalization = () => window.SafeWalkV6RealGifts?.readPersonalization(personalizationControls) || {};
    const api = {
      form,
      idInput,
      atcButtons,
      submitButtons,
      stickyAtcLabels,
      labels,
      kaching,
      hideAccessoryAddons,
      giftMode,
      giftContractMode,
      cartGiftVariantId,
      cartGiftProductId,
      cartGiftRequired,
      realGiftsRequired,
      realGiftIdentities,
      normalizeColor,
      normalizeSize,
      discountedLinePrice,
      formatMoney,
      findVariant,
      selectedPackageKey,
      resolvePackage,
      updatePackageSelection,
      updatePackageSurfaces,
      setStatus,
      setSuccess,
      setBusy: setSubmittingState,
      isBusy: () => busy,
      getPackageState: () => packageState,
      currentColor,
      currentSize,
      showError,
      showErrorStatus,
      clearError,
      setActiveSubmitter,
      createGroupId,
      properties,
      personalization
    };
    root.swv5Purchase = api;

    const initializedOptionIndexes = new Set();
    root.querySelectorAll('[data-option-value]:checked').forEach((input) => {
      const position = optionIndexFor(input);
      if (!Number.isInteger(position) || initializedOptionIndexes.has(position)) return;
      initializedOptionIndexes.add(position);
      syncVariantInputs(input);
    });
    const personalizationNames = new Set(personalizationControls.map(personalizationKey).filter(Boolean));
    personalizationNames.forEach((name) => {
      const mirrors = personalizationControls.filter((input) => personalizationKey(input) === name);
      const source = mirrors.find((input) => input.value) || mirrors[0];
      if (!source) return;
      mirrors.forEach((input) => { input.value = source.value; });
    });
    personalizationControls.forEach((input) => {
      const syncPersonalization = () => {
        personalizationControls.forEach((mirror) => {
          if (mirror !== input && personalizationKey(mirror) === personalizationKey(input)) mirror.value = input.value;
        });
      };
      listen(input, 'input', syncPersonalization);
      listen(input, 'change', syncPersonalization);
    });
    root.querySelectorAll('[data-option-value]').forEach((input) => {
      listen(input, 'change', () => {
        if (busy) return;
        syncVariantInputs(input);
        updateVariant(Boolean(input.closest('.swv5-option--color')));
        root.dispatchEvent(new CustomEvent('swv5:selection-change', { bubbles: true }));
      });
    });
    root.querySelectorAll('[data-package-input]').forEach((input) => {
      listen(input, 'change', () => {
        if (busy) return;
        clearError();
        updatePackageSelection(findVariant(), input);
        root.dispatchEvent(new CustomEvent('swv5:selection-change', { bubbles: true }));
      });
    });
    listen(root, 'click', (event) => setActiveSubmitter(event.target.closest?.('[data-swv5-submit]')), true);
    listen(form, 'submit', (event) => setActiveSubmitter(event.submitter), true);
    if (!addonMode) atcPrices.forEach((priceNode) => {
      const observer = new MutationObserver(() => {
        if (!packageState) return;
        const expected = formatMoney(packageState.total);
        if (priceNode.textContent.trim() !== expected) priceNode.textContent = expected;
      });
      observer.observe(priceNode, { childList: true, characterData: true, subtree: true });
      addCleanup(() => observer.disconnect());
    });
    updateVariant(false);
    root.dispatchEvent(new CustomEvent('swv5:purchase-ready', { bubbles: true, detail: { api } }));
    return () => {
      if (root.swv5Purchase === api) delete root.swv5Purchase;
      if (initialized) document.body.removeAttribute('data-swv5-leash-choice');
    };
  });
})();
